// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-1qjWp0hL clearfix","box":"box-lfALMhdb"};